<template>
  <div class="stat-panel h-100">
    <div class="stat-panel-head">
      <div>
        <h5>پرفروش‌ترین‌های ماه</h5>
        <p class="text-muted mb-0 small">بر اساس ماه و سال انتخابی</p>
      </div>
      <i class="bi bi-calendar3 text-primary"></i>
    </div>

    <div class="stat-select-row">
      <div>
        <label>سال</label>
        <select @change="changePage(1)" v-model="form.year" class="custom-select">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>
      <div>
        <label>ماه</label>
        <select @change="changePage(1)" v-model="form.month" class="custom-select">
          <option v-for="month in months" :key="month.value" :value="month.value">
            {{ month.name }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="topSellProducts.length" class="table-responsive">
      <table class="stat-table text-center">
        <thead>
        <tr>
          <th width="48">رتبه</th>
          <th class="text-right">نام محصول</th>
          <th>تعداد فروش</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in topSellProducts" :key="item.id || index">
          <td>
            <span class="stat-rank" :class="{'is-top': index === 0}">{{ index + 1 }}</span>
          </td>
          <td class="stat-product-name">{{ item.name }}</td>
          <td>
            <span class="stat-pill is-sales">{{ formatNumber(item.order_count) }}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="stat-empty">
      <i class="bi bi-calendar"></i>
      <p class="mb-0">در این ماه فروش محصولی ثبت نشده است.</p>
    </div>

    <div class="stat-pager text-center">
      <pagination :meta="pagination" :on-change-page="changePage"/>
    </div>
  </div>
</template>

<script>
import Pagination from "../../dashboard/Pagination.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "StatisticTopSellProductOfMonth",
  components: {Pagination},
  data() {
    return {
      form: {
        page: 1,
        month: parseInt(new Date().toLocaleDateString('fa-IR-u-nu-latn', {month: '2-digit'})),
        year: Number(new Date().toLocaleDateString('fa-IR-u-nu-latn', {year: 'numeric'})),
      },
      pagination: [],
      topSellProducts: [],
      months: [
        {value: 1, name: 'فروردین'},
        {value: 2, name: 'اردیبهشت'},
        {value: 3, name: 'خرداد'},
        {value: 4, name: 'تیر'},
        {value: 5, name: 'مرداد'},
        {value: 6, name: 'شهریور'},
        {value: 7, name: 'مهر'},
        {value: 8, name: 'آبان'},
        {value: 9, name: 'آذر'},
        {value: 10, name: 'دی'},
        {value: 11, name: 'بهمن'},
        {value: 12, name: 'اسفند'},
      ]
    }
  },
  computed: {
    years() {
      const currentYear = Number(
          new Intl.DateTimeFormat('fa-IR-u-ca-persian-nu-latn', {
            year: 'numeric'
          }).format(new Date())
      )

      const list = []
      for (let i = -5; i <= 5; i++) {
        list.push(currentYear + i)
      }

      if (!this.form.year) {
        this.form.year = currentYear
      }

      return list
    }
  },
  methods: {
    formatNumber,
    getTopSellProducts(form) {
      this.$store.dispatch('Statistic/topSellProductOfMonth', form).then(res => {
        let baseData = res.data.data;
        this.topSellProducts = baseData.data
        this.pagination = baseData.meta
      });
    },
    changePage(page) {
      this.form.page = page
      this.getTopSellProducts(this.form)
    },
  },
  mounted() {
    this.getTopSellProducts(this.form)
  }
}
</script>
